import React from 'react'
import NumberFormat  from 'react-number-format'

import { validateEmail } from 'core/utilities'
import { listAttachment } from './data'

export const convert2Decimal = (value, decimals=2) => {
  decimals = decimals || 0;
  return ( Math.floor( value * Math.pow(10, decimals) ) / Math.pow(10, decimals) );
}

export const numberFormat = (value, allowNegative = false,decimalScale=2) => {
  return (
  <NumberFormat 
    className='centerContent' 
    thousandSeparator=',' 
    value={value} 
    displayType='text'
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    fixedDecimalScale />
  )
}

export const validateField = (values,actionName=null) => {
  let errors = {}
  if(actionName=='save'){
    if (!values.title) {
      errors.title = 'Required!'
    }
    if (!values.poId) {
      errors.poId = 'Required!'
    }
    return errors
  }
  
  if (!values.title) {
    errors.title = 'Required!'
  }
  if (!values.poId) {
    errors.poId = 'Required!'
  }
  if (!values.requestContract) {
    errors.requestContract = 'Required!'
  }
  if (!values.typeOfContract) {
    errors.typeOfContract = 'Required!'
  }
  if (values.typeOfContract&&values.typeOfContract.find(x=>x.toLowerCase()=='tc06')) {
    if (!values.typeOfContractOther) {
      errors.typeOfContractOther = 'Required!'
    }
  }
  if (!values.amountOfPaymentType) {
    errors.amountOfPaymentType = 'Required!'
  }
  if (!values.payerOfStampDuty) {
    errors.payerOfStampDuty = 'Required!'
  }
  if (!values.startDate) {
    errors.startDate = 'Required!'
  }
  if (!values.endDate) {
    errors.endDate = 'Required!'
  }
  if (!values.dateOfPurpose) {
    errors.dateOfPurpose = 'Required!'
  }
  if (!values.prRequester) {
    errors.prRequester = 'Required!'
  }
  if (!values.prRequesterMobile) {
    errors.prRequesterMobile = 'Required!'
  }
  if (!values.purchasing) {
    errors.purchasing = 'Required!'
  }
  if (!values.purchasingMobile) {
    errors.purchasingMobile = 'Required!'
  }
  if (!values.supplierName) {
    errors.supplierName = 'Required!'
  }
  if (!values.supplierMobile) {
    errors.supplierMobile = 'Required!'
  }
  if (!values.supplierEmail) {
    errors.supplierEmail = 'Required!'
  }else{
    if(!validateEmail(values.supplierEmail)){
      errors.supplierEmail = 'Invalid email address!'
    }
  }
  return errors
}

export const validateAttachments = (values) => {
  const errors = []
  listAttachment.forEach((dt) => {
    const name = dt.name.toLowerCase()
    if (dt.require) {
      let docValue = values[name]
      if (docValue) {
        if (!docValue.length) {
          errors.push({ fieldName: dt.label, message: 'Required!' })
        }
      } else {
        if(!values.attachments){
          errors.push({ fieldName: dt.label, message: 'Required!' })
        }else{
          const checkDoc = values.attachments.filter(a => a.documentType.toLowerCase() === name && !a.deleted)
          if (!checkDoc.length) {
            errors.push({ fieldName: dt.label, message: 'Required!' })
          }
        }
      }
    }
  })
  return errors
}

export const validatePaymentConditions = (values) => {
  if(!values.paymentConditions.length){
    return false
  }else{
    let check = true
    values.paymentConditions.forEach((x)=>{
      check = check?((x.installment&&x.installmentPayment)||(x.deleted)):false
    })
    return check
  }
}